import ClampText from '@wix/wix-vod-shared/src/common/components/clamp-text/clamp-text';
import PropTypes from 'prop-types';

const defaultClampOptions = {
  lineClamp: 2,
};

const Title = ({ text, clampOptions = {} }) => (
  <ClampText text={text}
             dataHook="title"
             clampOptions={{ ...defaultClampOptions, ...clampOptions }} />
);

Title.propTypes = {
  text: PropTypes.string,
  clampOptions: PropTypes.object,
};

export default Title;



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/partials/title.js